// extracted by mini-css-extract-plugin
module.exports = {"divider":"community-module--divider--C3_z0"};